import { Config } from '../../config'

export const labproConfig: Config = {
  partner: 'labpro',
  catalog: 'partner',
  displayName: 'Lab Pro',
  accentColor: '#47538a',
  host: 'seating.labproinc.com',
  extraAttributes: {
  }
}
